export default __webpack_public_path__ + "static/media/transland-trucks-2.02714e79.jpg";